import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface ExpandIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const ExpandIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: ExpandIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M8.17157 16.0355L16.3033 7.90379"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M7.81802 10.7322L7.81803 15.3891C7.81801 15.9414 8.26575 16.3891 8.81802 16.3891L13.4749 16.3891"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M16.5962 13.2678L16.5962 8.61092C16.5962 8.05865 16.1485 7.61091 15.5962 7.61093L10.9393 7.61092"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default ExpandIcon
